// src/pages/GramsevakServiceBook.js
import React from "react";

const GramsevakServiceBook = () => {
  const gramPanchayat = {
    name: "ग्रामपंचायत वलनी",
    taluka: "नागपूर",
    district: "नागपूर",
    pincode: "441501",
    area: "405.08 हेक्टर",
    contact: "9765088087",
    email: "grampanchayatvalni@gmail.com",
    website: "gpwalni.in",
  };


  const gramsevak = {
    name: "श्री.व्ही.आर.निस्ताने",
    designation: "ग्रामपंचायत अधिकारी",
    currentPosting: "ग्रामपंचायत वलनी",
    photo: `${process.env.PUBLIC_URL}/images/Gramsevak.png`, // तुझ्या फोल्डरमधला फोटो
  };

  const logo = `${process.env.PUBLIC_URL}/images/national emblem.png`; // सरकारी लोगो
  const gpLogo = `${process.env.PUBLIC_URL}/images/gp.jpeg`; // ग्रामपंचायत लोगो

  return (
    <div style={styles.container}>
      {/* ===== सरकारी हेडर ===== */}
      <header style={styles.govHeader}>
        <img src={logo} alt="Maharashtra Logo" style={styles.emblemImg} />
        <div style={styles.govTitle}>
          <h1 style={styles.govName}>महाराष्ट्र शासन</h1>
          <h2 style={styles.dept}>ग्रामविकास विभाग | जिल्हा परिषद नागपूर</h2>
        </div>
      </header>

      {/* ===== मुख्य हेडर ===== */}
      <header style={styles.mainHeader}>
        <img src={gpLogo} alt="Gram Panchayat Logo" style={styles.gpLogo} />
        <div style={styles.title}>
          <h1 style={styles.gpName}>{gramPanchayat.name}</h1>
          <p style={styles.gpInfo}>
            तालुका: {gramPanchayat.taluka} | जिल्हा: {gramPanchayat.district} | पिनकोड:{" "}
            {gramPanchayat.pincode}
          </p>
        </div>
      </header>
    {/* ===== ग्रामसेवक माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रामपंचायत अधिकारी</h2>
        <div style={styles.infoGrid}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>नाव</span>
            <span style={styles.infoValue}>{gramsevak.name}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>पद</span>
            <span style={styles.infoValue}>{gramsevak.designation}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>सध्याची पोस्टिंग</span>
            <span style={styles.infoValue}>{gramsevak.currentPosting}</span>
          </div>

          {/* ग्रामसेवक फोटो */}
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>फोटो</span>
            <img src={gramsevak.photo} alt="Gramsevak" style={styles.gramsevakPhoto} />
          </div>
        </div>
      </section>

      {/* ===== कर्तव्ये ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>मुख्य कर्तव्ये</h2>
        <ul style={styles.dutyList}>
          <li>ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li>कर वसुली, पाणीपट्टी, स्वच्छता शुल्क</li>
          <li>मनरेगा, स्वच्छ भारत, PMAY योजनांची अंमलबजावणी</li>
          <li>जन्म-मृत्यू, लग्न नोंदणी</li>
          <li>ग्रामपंचायत अभिलेख (नमुना १ ते ३३) ठेवणे</li>
        </ul>
      </section>
      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <div style={styles.footerLine}></div>
        <p style={styles.footerText}>
          ही सेवा पुस्तिका <strong>महाराष्ट्र नागरी सेवा (सेवा पुस्तिका) नियम १९८१</strong> नुसार तयार केली आहे.
        </p>
        <p style={styles.copyright}>
          © २०२५ जिल्हा परिषद नागपूर | ग्रामविकास विभाग
        </p>
      </footer>
    </div>
  );
};

// ===== Improved CSS Styles =====
const styles = {
  container: {
    fontFamily:
      "'Noto Sans Devanagari', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "980px",
    margin: "20px auto",
    padding: "32px",
    background: "#ffffff",
    border: "3px solid #145a32",
    borderRadius: "18px",
    boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
    color: "#0a2e13",
    lineHeight: "1.75",
  },

  // Government Header
  govHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(90deg, #ff9933 0%, #ffffff 50%, #128807 100%)",
    padding: "22px",
    borderRadius: "14px 14px 0 0",
    margin: "-32px -32px 30px -32px",
    textAlign: "center",
    borderBottom: "3px solid #145a32",
  },
  emblemImg: {
    width: "70px",
    height: "70px",
    marginRight: "18px",
    borderRadius: "50%",
    border: "3px solid #222",
  },
  govTitle: {
    flex: 1,
  },
  govName: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "bold",
    color: "#002366",
  },
  dept: {
    margin: "5px 0 0 0",
    fontSize: "16px",
    fontWeight: "600",
    color: "#0d531a",
  },

  // Main GP Header Section
  mainHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    padding: "22px",
    background: "linear-gradient(135deg, #e9f7ef, #d4efdf)",
    borderRadius: "14px",
    border: "2px solid #a9dfbf",
  },
  gpLogo: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    marginRight: "22px",
    border: "3px solid #1e8449",
  },
  title: {
    flex: 1,
  },
  gpName: {
    margin: "0 0 10px 0",
    fontSize: "32px",
    color: "#145a32",
    fontWeight: "bold",
  },
  gpInfo: {
    margin: "0 0 5px 0",
    fontSize: "18px",
    color: "#1b5e20",
    fontWeight: "600",
  },

  // Card Box Styling
  card: {
    background: "#ffffff",
    padding: "28px",
    borderRadius: "14px",
    marginBottom: "28px",
    border: "2px solid #c8e6c9",
    boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    color: "#0d531a",
    fontSize: "24px",
    fontWeight: "700",
    margin: "0 0 20px 0",
    paddingBottom: "10px",
    borderBottom: "3px solid #76d7c4",
    letterSpacing: "0.5px",
  },

  // Info Rows
  infoGrid: {
    display: "grid",
    gap: "14px",
  },
  infoRow: {
    display: "flex",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #b8e994",
    background: "#f4fdf0",
  },
  infoLabel: {
    background: "#1e8449",
    color: "#fff",
    padding: "12px 18px",
    fontWeight: "bold",
    width: "42%",
    fontSize: "16px",
  },
  infoValue: {
    padding: "12px 18px",
    background: "#fcfff5",
    flex: 1,
    fontSize: "16px",
    color: "#0a3d1b",
    fontWeight: "500",
  },
  link: {
    padding: "12px 18px",
    display: "block",
    flex: 1,
    fontSize: "16px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#0d531a",
  },

  // Photo
  gramsevakPhoto: {
    width: "125px",
    height: "150px",
    borderRadius: "10px",
    margin: "10px",
    border: "3px solid #1e8449",
    objectFit: "cover",
  },

  // Duty List
  dutyList: {
    paddingLeft: "24px",
    fontSize: "16px",
    color: "#0a3d1b",
    lineHeight: "1.9",
  },

  // Footer Section
  footer: {
    textAlign: "center",
    paddingTop: "35px",
  },
  footerLine: {
    height: "2px",
    background: "linear-gradient(to right, transparent, #26ae60, transparent)",
    marginBottom: "18px",
  },
  footerText: {
    fontSize: "16px",
    color: "#1e8449",
    fontWeight: "600",
  },
  copyright: {
    fontSize: "13.5px",
    color: "#777",
    marginTop: "10px",
  },
};

export default GramsevakServiceBook;